import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Articles from '../Articles/Articles';

class ModalBuscarConteudo extends React.Component {
    constructor(props) {
        super(props);

        this.posicaoModal = this.posicaoModal.bind(this);

    }

    posicaoModal() {
        const {
            posicao
        } = this.props;

        let _tituloPrioridade;

        switch (posicao) {
            case 1: _tituloPrioridade = "Primário"; break;
            case 2: _tituloPrioridade = "Secundário"; break;
            case 3: _tituloPrioridade = "Terciário"; break;
            default: _tituloPrioridade = ""; break;
        }
        return _tituloPrioridade;
    }


    render() {
        const {
            isOpen, toggle, periodico, isLoadingArtigos, listaArtigos,
            atualizarDestaque, buscarTermos, handleChange, termo, ordenacao
        } = this.props;
        return (
            <div>
                <Modal size="lg" className="modal-buscar-conteudo" isOpen={isOpen} toggle={toggle}>
                    <ModalHeader toggle={toggle}>
                        Buscar conteúdo - {this.posicaoModal()} - {periodico}
                    </ModalHeader>
                    <ModalBody>
                        <form onSubmit={buscarTermos}>
                            <div className="row no-gutters">
                                <div className="col-5">
                                    <input name="termo" type="text" className="form-control" autoComplete="off" placeholder="Insira uma palavra"
                                        value={termo} onChange={handleChange} />
                                </div>
                                <div className="col-4 text-right">
                                    <div className="form-group m-0">
                                        <label htmlFor="ordenacao"> Ordenar por: </label>
                                        <select className="ml-2" name="ordenacao" id="ordenacao" value={ordenacao} onChange={handleChange}>
                                            <option value="date">mais recentes</option>
                                            <option value="score">mais relevantes</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3 text-right">
                                    <button className="btn btn-outline-success" >Buscar</button>
                                </div>
                            </div>
                        </form>

                        <div className="row no-gutters mt-4">
                            <span>Últimos artigos publicados </span>
                        </div>
                        {isLoadingArtigos ? (
                            <div className="col-12 text-center px-3 py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <div className="col-12">
                                <div className="row lista-artigos">
                                    {listaArtigos.map((item, index) => {
                                        return (
                                            <div className="col-12 py-2" key={index}>
                                                <Articles
                                                    item={item}
                                                    mudaStatusArtigo={() => { }}
                                                    history={this.props.history}
                                                    match={this.props.match}
                                                    flagTelaDestaque={true}
                                                    atualizarDestaque={atualizarDestaque}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        );
    }

}

export default ModalBuscarConteudo;